import React from 'react';
import { Newspaper, X } from 'lucide-react';

const DEFAULT_IMAGE = '/logo.svg';

const NewsModal = ({ news, isOpen, onClose }) => {
  if (!isOpen || !news) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-2xl max-h-[90vh] overflow-y-auto bg-white rounded-xl shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute right-3 top-3 z-10 p-2 rounded-full bg-white/90 hover:bg-white shadow-lg transition-colors"
          aria-label="Закрыть"
        >
          <X className="w-5 h-5 text-gray-600" />
        </button>

        {news.image && (
          <div className="w-full h-64 sm:h-80 bg-gray-100 overflow-hidden flex items-center justify-center">
            <img
              src={news.image}
              alt={news.title}
              className="max-w-full max-h-full object-contain"
              onError={(e) => {
                e.target.src = DEFAULT_IMAGE;
              }}
            />
          </div>
        )}

        <div className="p-5 sm:p-6">
          <div className="flex items-center gap-2 text-sm text-blue-600 mb-3">
            <Newspaper className="w-4 h-4" />
            <span className="font-medium">{news.date}</span>
          </div>
          <h2 className="text-xl sm:text-2xl font-bold mb-4 pr-8">{news.title}</h2>
          <p className="text-gray-600 leading-relaxed whitespace-pre-line">
            {news.fullText || news.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NewsModal;
